// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2JYP1","header":"ReportDetails_header__In-oY","title":"ReportDetails_title__1OSeu","left":"ReportDetails_left__hECDq"};